export const bg_button =
  "bg-gradient-to-r from-[#2EA5A1] via-[#32B7C2] to-[#6CC4B0]";
export const bg_text =
  "bg-gradient-to-r from-[#2EA5A1] via-[#32B7C2] to-[#6CC4B0] bg-clip-text leading-tight text-transparent";
export const bg_shadow =
  "shadow-[0_4px_12px_rgba(46,165,161,0.4)] hover:shadow-[0_6px_16px_rgba(46,165,161,0.5)]";

export const bg_shadow_low =
  "shadow-[0_4px_12px_rgba(46,165,161,0.2)] hover:shadow-[0_6px_12px_rgba(46,165,161,0.2)]";
export const text_color = "text-[#2EA5A1]";
